import AccountDetailSection from "features/accounts/sections/AccountDetailSection";
import { useCustomerSimplified } from "features/customer/hooks/useCustomerSimplified";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

interface RouteProps {
  customerId: string;
  accountId: string;
}

const CustomerAccountDetail = () => {
  // translation
  const tLabels = useTranslation("shared\\moduleNames").t;

  const { customerId, accountId } = useParams<RouteProps>();
  const { customer } = useCustomerSimplified(customerId, true);

  return (
    <>
      <Header
        title={tLabels("customerAccountDetail.title")}
        subtitle={customer ? customer.name : ""}
        includeBreadcrumbs
        links={[
          { to: "/customers", text: tLabels("allCustomerSelect.title") },
          { to: `/customers/${customerId}/accounts`, text: tLabels("customerAccounts.title") }
        ]}
      />
      <ModuleContent>
        <AccountDetailSection 
          accountId={accountId} 
          forAdminUse
        />
      </ModuleContent>
    </>
  );
};

export default CustomerAccountDetail;
